import type { ComponentSchema } from '../../../schema-types'
import { SECTION_STYLE_FIELDS } from '../../lightings/lightings-1/_builder-constants'

/** Card instalment (EMI) table for an amount: monthly, total and interest per plan, with the partner banks. */
export const schema: ComponentSchema = {
  type: 'emi-calculator',
  label: 'EMI calculator',
  description: 'Shoppers enter an amount and see the monthly instalment of each EMI plan you offer.',
  supportedPages: ['tools'],
  variants: [{ id: 'v1', label: 'Plan table' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'EMI calculator' },
    { key: 'intro', label: 'Intro', type: 'text', default: 'Pay in easy monthly instalments with your credit card.' },
    { key: 'defaultAmount', label: 'Starting amount', type: 'number', default: 50000, help: 'A link with ?amount= (from a product page) fills its own amount.' },
    {
      key: 'plans',
      label: 'Plans',
      type: 'array',
      itemSchema: [
        { key: 'months', label: 'Months', type: 'number', default: 6 },
        { key: 'annualRate', label: 'Interest a year (%)', type: 'number', default: 0 },
        { key: 'feePercent', label: 'Processing fee (%)', type: 'number', default: 0 },
      ],
      default: [
        { months: 3, annualRate: 0, feePercent: 3 },
        { months: 6, annualRate: 0, feePercent: 4.5 },
        { months: 9, annualRate: 0, feePercent: 6.5 },
        { months: 12, annualRate: 0, feePercent: 8.5 },
        { months: 18, annualRate: 0, feePercent: 11.5 },
        { months: 24, annualRate: 0, feePercent: 14.5 },
      ],
    },
    { key: 'banks', label: 'Partner banks', type: 'array', itemSchema: [{ key: 'name', label: 'Bank', type: 'string' }], default: [] },
    { key: 'note', label: 'Note', type: 'text', default: 'EMI is available on credit cards of partner banks. The bank may charge its own fees.' },
    ...SECTION_STYLE_FIELDS,
  ],
}
